// extracted by mini-css-extract-plugin
export default {"link_name":"Logo_link_name__bjmXp","symbol_text":"Logo_symbol_text__bD9Wr","developer_name":"Logo_developer_name__JAdJr"};